import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { ApiCallService } from './api-call.service';
import { Params } from '@angular/router';
import { Property, PropertySearch, AdvancedLimits } from './../models/index';
import { Router, Resolve, ActivatedRouteSnapshot } from '@angular/router';
import * as Raven from 'raven-js';

@Injectable()
export class PropertyService extends BaseApiService implements Resolve<Property> {
  constructor(
    private apiCallService: ApiCallService,
    private router: Router
  ) {
    super();
  }

  getProperties(propertySearch?: PropertySearch, sort?: string, page?: number): Promise<Property[]> {
    let path = '/new_properties';

    if (propertySearch) {
      path += this.apiCallService.getSeachUrlParams(propertySearch, sort, page);
    }
    return this.apiCallService.get(path);
  }

  decodeUrlParams(params: Params, advancedLimits?: AdvancedLimits, oldPropertySearch?: PropertySearch): PropertySearch {
    Raven.captureBreadcrumb({
      message: 'PropertyService.decodeUrlParams',
      category: 'search',
      data: {
        params: params,
        advanced_limits: advancedLimits
      }
    });
    let propertySearch = null;
    if (oldPropertySearch) {
      propertySearch = oldPropertySearch;
    } else {
      propertySearch = new PropertySearch();
    }

    for (const field in params) {
      if (params.hasOwnProperty(field) && params[field] && params[field].length) {
        if (Array.isArray(propertySearch[field])) {
          if (Array.isArray(params[field])) {
            if (params[field].every((e, i, a) => isNaN(+e))) {
              propertySearch[field] = params[field];
            } else {
              propertySearch[field] = params[field].map(param => +param);
            }
          } else {
            if (+params[field]) {
              propertySearch[field] = [+params[field]];
            } else {
              propertySearch[field] = [params[field]];
            }
          }
        } else if (typeof propertySearch[field] === 'boolean') {
          propertySearch[field] = params[field] === 'true';
        } else if (!isNaN(params[field]) && field !== 'number') {
          propertySearch[field] = +params[field];
        } else {
          propertySearch[field] = params[field];
        }
      }
    }

    if (advancedLimits) {
      for (const field in advancedLimits) {
        if (advancedLimits.hasOwnProperty(field) && propertySearch[field] === null) {
          propertySearch[field] = advancedLimits[field];
        }
      }
    }
    return propertySearch;
  }

  getPromoProperties(): Promise<Property[]> {
    return this.apiCallService.get('/new_properties/promo');
  }

  getProperty(friendly_id: string): Promise<Property> {
    return this.apiCallService.get('/properties/' + friendly_id + '?token=secrettokenpreview');
  }

  generateBreadcrums(property: Property): any {
    return [];
  }

  resolve(route: ActivatedRouteSnapshot): Promise<Property> {
    let promise;

    const page = route.data['page'] ? route.data['page'] : 1;

    if (route.params['friendly_id'] === undefined) {

      if (route.data['property_search']) {

        promise = this.getProperties(route.data['property_search'], undefined, page);

      } else if (route.data['property_type']) {

        const propertySearch = this.decodeUrlParams(route.queryParams);
        propertySearch.property_type = route.data['property_type'];
        promise = this.getProperties(propertySearch, undefined, page);

      } else {
        promise = this.getProperties(new PropertySearch(), undefined, 1);
      }
    } else {
      promise = this.getProperty(route.params['friendly_id'])
        .catch(error => {
          this.router.navigate(['/apartamente']);
          throw error;
        });
    }

    return promise;
  }

  generateCharacteristicsString(property: Property): string {
    const str = new Array();
    if (property.property_type === 'apartamente' || property.property_type === 'casevile') {

      if (property.has_basement) {
        str.push('S');
      }

      if (property.has_semi_basement) {
        str.push('D');
      }

      str.push('P');

      if (property.floor_count)
        str.push(property.floor_count.toString() + 'E');

      if (property.has_loft) {
        str.push('M');
      }
    }
    return str.join(' + ');
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/api/property.service.ts